<template>
  <v-row no-gutters>
    <v-col v-if="Object.hasOwn(item, 'date')" class="pa-2" cols="12" md="8">
      <custom-date-picker
        v-model="computedDate"
        label="تاریخ انقضا"
        :min="nowDateTimeString()"
        auto-submit
        display-format="jYYYY-jMM-jDD HH:mm:ss"
        format="YYYY-MM-DD HH:mm:ss"
        type="datetime"
        @input="updateDate"
      />
      <!-- <v-col cols="12" class="pa-2">
        <v-btn
          block
          class="rounded-pill"
          color="blue lighten-4"
          @click="saveDate"
          :disabled="!computedDate"
        >
          افزودن تاریخ
        </v-btn>
      </v-col> -->
      <span v-show="!computedDate" class="red--text"
        >انتخاب تاریخ الزامی است.</span
      >
    </v-col>
  </v-row>
</template>
<script>
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  name: "setDate",

  components: { CustomDatePicker },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {
    computedDate: {
      get() {
        console.log("Computed date:", this.item.date);
        return this.item.date;
      },
      set(value) {
        this.$emit("update:item", { ...this.item, date: value });
      },
    },
    computedItem: {
      get() {
        return this.item;
      },
      set(value) {
        this.$emit("update:item", value);
      },
    },
  },

  methods: {
    // nowDateTimeString() {
    //   const now = new Date();
    //   return now.toISOString().slice(0, 19).replace("T", " ");
    // },
    updateDate(value) {
      this.$emit("update:item", { ...this.item, date: value });
    },
    saveDate() {
      this.$emit("save-date", this.item.date);
    },
  },
};
</script>
<style scoped></style>
